module.exports = __webpack_public_path__ + "static/img/brees-2010-slide-5.f9d619f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2010-slide-5.jpg
// module id = mu0K
// module chunks = 1